// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__25vyi","item":"PaymentsMobile_item__Fe34h","label":"PaymentsMobile_label__3d50J","amount":"PaymentsMobile_amount__1wYOh"};